@if (config$ | async; as config) {
  <vex-base-layout>
    <vex-progress-bar></vex-progress-bar>
    <app-offline-banner></app-offline-banner>
    <app-stale-session-banner></app-stale-session-banner>

    <vex-search></vex-search>

    <mat-sidenav-container class="vex-layout-sidenav-container">
      <mat-sidenav
        (closedStart)="onSidenavClosed()"
        [disableClose]="!!(sidenavDisableClose$ | async)"
        [fixedInViewport]="!!(sidenavFixedInViewport$ | async)"
        [mode]="(sidenavMode$ | async) ?? 'side'"
        [opened]="!!(sidenavOpen$ | async)">
        <vex-sidenav [collapsed]="!!(sidenavCollapsed$ | async)"></vex-sidenav>
      </mat-sidenav>

      <mat-sidenav
        (closedStart)="onQuickpanelClosed()"
        [opened]="!!(quickpanelOpen$ | async)"
        class="vex-layout-quickpanel"
        mode="over"
        position="end">
        <vex-quickpanel></vex-quickpanel>
      </mat-sidenav>

      <mat-sidenav-content class="vex-layout-sidenav-content">
        <vex-toolbar
          [class.dark]="config.layout === 'vertical'"
          class="vex-toolbar">
          <!--
            Sync, shop status and signal were three separate bordered chips
            competing for the same corner. They are one pill now: the wrapper
            owns the chrome and the dot separators, and each child renders as a
            bare segment that still carries its own state colour and still
            opens its own popover.
          -->
          <div
            vexToolbarStart
            class="flex-1 flex justify-end items-center gap-2">
            <div class="erp-status-pill">
              <app-offline-status-pill></app-offline-status-pill>
              <app-availability-status-pill></app-availability-status-pill>
              <app-connection-strength-indicator></app-connection-strength-indicator>
            </div>
            <app-pwa-install-button></app-pwa-install-button>
          </div>
        </vex-toolbar>

        <main class="vex-layout-content">
          <router-outlet></router-outlet>
        </main>

        <!-- <vex-footer *ngIf="config.footer.visible" class="vex-footer"></vex-footer> -->
      </mat-sidenav-content>
    </mat-sidenav-container>

    @if (false) {
      <vex-config-panel-toggle
        (openConfig)="configpanel.open()"></vex-config-panel-toggle>
    }

    @if (false) {
      <button
        class="absolute bottom-32 right-6 z-20 p-2 rounded-full bg-red-400 text-white shadow-lg"
        [appSidePanelTrigger]="itemPopover"
        [preventClickPropagation]="true">
        New Item
      </button>
    }

    <!-- CONFIGPANEL -->
    <vex-sidebar
      #configpanel
      [invisibleBackdrop]="true"
      [opened]="!!(configPanelOpen$ | async)"
      position="right">
      <vex-config-panel></vex-config-panel>
    </vex-sidebar>

    <!-- END CONFIGPANEL -->
  </vex-base-layout>
}
<ng-template #itemPopover let-overlayRef="overlayRef" let-detach="detach">
  <app-shared-side-panel [overlayRef]="overlayRef" [detachOverlay]="detach">
    <div class="flex gap-2">
      <button
        type="button"
        class="app-button app-button-outline"
        (click)="detach()">
        Cancel
      </button>
    </div>
  </app-shared-side-panel>
</ng-template>
